import Dashboard from "layouts/dashboard";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import Branch from "layouts/branch/index";
import AddingSecurityDeposits from "layouts/SetSecurityDeposit";
import Icon from "@mui/material/Icon";
import BuildingsTracker from "layouts/roomavailabilitytracker/buildings";
import ForgotBasic from "layouts/authentication/forgot-password";
import Cover from "layouts/authentication/reset-password/cover";
import ArchivedGuests from "layouts/archivedCheckouts";
import AllTransactions from "layouts/allTrasactions";
import GuestReportMain from "./layouts/GuestReport/index";
import PendingPayments from "layouts/pendingPayments";
import ConfigRentsIndex from "layouts/configRents";
import TransactionDownloadData from "layouts/downloadData";
import LoginDetails from "./layouts/loginInfo";
import TRS from "layouts/dashboard/components/summaryTables/recentIndex";
import ExceededGuest from "layouts/upcomingCheckouts/ExceededGuestIndex";
import TodaysCheckOutIndex from "layouts/upcomingCheckouts/TodaysCheckoutIndex";
import ManualPage from "layouts/announcements";
import BedHistoryIndex from "layouts/bedHistory";
import MonthlySummary from "layouts/MonthlySummary";
import DailyReportMain from "layouts/inventory";
const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard authorized={true} />,
  },
  {
    type: "collapse",
    name: "Room Availability Tracker",
    key: "tracker",
    icon: <Icon fontSize="small">home</Icon>,
    route: "/tracker",
    component: <BuildingsTracker buildingName="SREE_KALANILAYAM" />,
  },
  {
    type: "collapse",
    name: "Guest Onboarding",
    key: "profile",
    icon: <Icon fontSize="small">person_add</Icon>,
    route: "/profile",
    component: <Profile />,
  },

  {
    type: "collapse",
    name: "Branch & Employees",
    key: "branch",
    icon: <Icon fontSize="small">buildigs</Icon>,
    route: "/branch",
    component: <Branch />,
  },
  {
    type: "collapse",
    name: "Checkout Guests",
    key: "archivedGuests",
    icon: <Icon fontSize="small">archive</Icon>,
    route: "/archivedGuests",
    component: <ArchivedGuests />,
  },
  {
    type: "collapse",
    name: " Recent Transaction ",
    key: "recentTransactions",
    icon: <Icon fontSize="small">Recent Payments</Icon>,
    route: "/recenttransactions",
    component: <TRS />,
  },
  {
    type: "collapse",
    name: "Pending Payments",
    key: "PendingPayments",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/pendingpayments",
    component: <PendingPayments />,
  },
  {
    type: "main",
    name: "Todays Checkouts",
    key: "todaysCheckOuts",
    icon: <Icon fontSize="small">archive</Icon>,
    route: "/todaysCheckOuts",
    component: <TodaysCheckOutIndex />,
  },
  // {
  //   type: "collapse",
  //   name: "Dining Report",
  //   key: "dining",
  //   icon: <Icon fontSize="small">archive</Icon>,
  //   route: "/dining",
  //   component: <ReportIndex />,
  // },
  {
    type: "collapse",
    name: "Exceeded Guest",
    key: "exceededGuest",
    icon: <Icon fontSize="small">archive</Icon>,
    route: "/exceededGuest",
    component: <ExceededGuest />,
  },
  {
    type: "collapse",
    name: "Addmision Data",
    key: "guestData",
    icon: <Icon fontSize="small">manypersons</Icon>,
    route: "/guestData",
    component: <GuestReportMain />,
  },
  {
    type: "collapse",
    name: "Login Activity ",
    key: "loginDetails",
    icon: <Icon fontSize="small">Important</Icon>,
    route: "/loginDetails",
    component: <LoginDetails />,
  },
  {
    type: "collapse",
    name: "Download Transaction",
    key: "fetchTransactions",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/fetchTransactions",
    component: <TransactionDownloadData />,
  },
  {
    type: "collapse",
    name: "Monthly Summary",
    key: "monthlySummary",
    icon: <Icon fontSize="small">Important</Icon>,
    route: "/monthlySummary",
    component: <MonthlySummary />,
  },
  {
    type: "collapse",
    name: "Payments History",
    key: "allTransactions",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/allTransactions",
    component: <AllTransactions />,
  },
    {
    type: "collapse",
    name: "Daily Summary",
    key: "dailySummary",
    icon: <Icon fontSize="small">payments</Icon>,
    route: "/dailySummary",
    component: <DailyReportMain />,
  },

  // {
  //   type: "collapse",
  //   name: "InNotice Guest",
  //   key: "upcomingCheckouts",
  //   icon: <Icon fontSize="small">upcomingcheckout</Icon>,
  //   route: "/upcomingCheckouts",
  //   component: <InNotices />,
  // },
  // {
  //   type: "collapse",
  //   name: "Set Defaults",
  //   key: "configSecurityDeposit",
  //   icon: <Icon fontSize="small">send</Icon>,
  //   route: "/configure",
  //   component: <ConfigSecurityDeposits />,
  // },
  {
    type: "collapse",
    name: "Add Security Deposit",
    key: "addingSecurityDeposits",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/securityConfiguration",
    component: <AddingSecurityDeposits />,
  },
  {
    type: "collapse",
    name: "Configure Rents",
    key: "configRents",
    icon: <Icon fontSize="small">send</Icon>,
    route: "/configRents",
    component: <ConfigRentsIndex />,
  },
  {
    type: "collapse",
    name: "Bed History",
    key: "bedHistory",
    icon: <Icon fontSize="small">bed</Icon>,
    route: "/bedHistory",
    component: <BedHistoryIndex />,
  },
  {
    type: "collapse",
    name: "User Instruction",
    key: "manual",
    icon: <Icon fontSize="small">Important</Icon>,
    route: "/manual",
    component: <ManualPage />,
  },

  {
    type: "collapse",
    name: "Sign Out",
    key: "sign-out",
    icon: <Icon fontSize="small">logout</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },

  {
    type: "main",
    name: "Forgot Password",
    key: "forgot-password",
    icon: <Icon fontSize="small">Forgot Password</Icon>,
    route: "/forgotPassword",
    component: <ForgotBasic />,
  },
  {
    type: "main",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/resetPassword",
    component: <Cover />,
  },

  {
    type: "main",
    name: "Room Availability Tracker",
    key: "tracker/anandanilayam",
    icon: <Icon fontSize="small">booking</Icon>,
    route: "/tracker/anandanilayam",
    component: <BuildingsTracker buildingName="ANANDA_NILAYAM" />,
  },
  {
    type: "main",
    name: "Room Availability Tracker",
    key: "tracker/sreenilayam",
    icon: <Icon fontSize="small">booking</Icon>,
    route: "/tracker/sreenilayam",
    component: <BuildingsTracker buildingName="SREE_NILAYAM" />,
  },
];
export default routes;
